"use client";

import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { SiTiktok } from "react-icons/si";
import { useNavigate } from "react-router-dom";
import ConsultationForm from "../../../ConsultationProgram/ConsultationForm";

function Contact() {
  const navigate = useNavigate();
  const [consultOpen, setConsultOpen] = useState(false);

  return (
    <Box component="section" sx={{ py: { xs: 3, lg: 3 } }}>
      <Container maxWidth="lg">
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Box
              sx={{
                width: "100%",
                borderRadius: 3,
                overflow: "hidden",
                background: "",
                boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                mb: 6,
              }}
            >
              <Grid container sx={{ minHeight: { md: 500 } }}>
                <Grid
                  item
                  xs={12}
                  lg={5}
                  sx={{
                    backgroundColor: "transparent", // no background color
                    boxShadow: "5 8px 24px rgba(0,0,0,.8)", // subtle shadow
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                    p: { xs: 6, sm: 6, md: 6 },
                  }}
                >
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      variant="h3"
                      component="h2"
                      sx={{
                        color: "#FFFFFF",
                        mb: 2,
                        fontWeight: 600,
                        fontSize: { xs: "1.75rem", md: "2.5rem" },
                      }}
                    >
                      Contact Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "rgba(255, 255, 255, 0.85)",
                        mb: 4,
                        lineHeight: 1.6,
                      }}
                    >
                      Reach out directly or book a free consultation session —
                      we'd love to hear from you.
                    </Typography>

                    {/* Contact Details with consistent spacing */}
                    <Box sx={{ "& > *": { mb: 2 } }}>
                      {/* Phone */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <PhoneIcon sx={{ mr: 2, color: "#42a5f5" }} />
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255, 255, 255, 0.9)" }}
                        >
                          <a
                            href="tel:+201036689217"
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            +20 103 668 9217
                          </a>{" "}
                        </Typography>
                      </Box>

                      {/* Email */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <EmailIcon sx={{ mr: 2, color: "#42a5f5" }} />
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255, 255, 255, 0.9)" }}
                        >
                          <a
                            href="mailto:sales@thedevhouse.io"
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            sales@thedevhouse.io
                          </a>
                        </Typography>
                      </Box>

                      {/* Address */}
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <LocationOnIcon
                          sx={{ mr: 2, mt: 0.5, color: "#42a5f5" }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: "rgba(255, 255, 255, 0.9)" }}
                        >
                          <a
                            href="https://maps.app.goo.gl/qsGGdVL297g3bUG48"
                            style={{ color: "#ffff" }}
                          >
                            Heliopolis, Cairo, Egypt
                          </a>{" "}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Social Links */}
                    <Box sx={{ mt: 4 }}>
                      <IconButton
                        component="a"
                        href="https://www.facebook.com/profile.php?id=61583907059473"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                          color: "#ffffffff",
                          "&:hover": {
                            backgroundColor: "rgba(158, 158, 158, 0.1)",
                            transform: "scale(1.1)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <FacebookIcon />
                      </IconButton>
                      <IconButton
                        component="a"
                        href="https://www.instagram.com/thedevhouseco/"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                          color: "#ffffffff",
                          "&:hover": {
                            backgroundColor: "rgba(158, 158, 158, 0.1)",
                            transform: "scale(1.1)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <InstagramIcon />
                      </IconButton>
                      <IconButton
                        component="a"
                        href="https://www.linkedin.com/company/thedevhouse1"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                          color: "#ffffffff",
                          "&:hover": {
                            backgroundColor: "rgba(158, 158, 158, 0.1)",
                            transform: "scale(1.1)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <LinkedInIcon />
                      </IconButton>
                      <IconButton
                        component="a"
                        href="https://www.tiktok.com/@thedevhouse?_r=1&_t=ZS-93aVUqO32H3"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                          color: "#ffffffff",
                          "&:hover": {
                            backgroundColor: "rgba(158, 158, 158, 0.1)",
                            transform: "scale(1.1)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <SiTiktok />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  lg={7}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { xs: 3, sm: 4, md: 6 },
                    backgroundColor: "rgba(255, 255, 255,.95)",
                  }}
                >
                  <Box sx={{ textAlign: "center", maxWidth: 500 }}>
                    <Typography
                      variant="h2"
                      component="h3"
                      sx={{
                        color: "white",
                        mb: 2,
                        fontWeight: 600,
                        fontSize: { xs: "2rem", md: "3rem" },
                      }}
                    >
                      Say Hi!
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "rgba(0, 0, 0, 0.8)",
                        mb: 4,
                        lineHeight: 1.6,
                      }}
                    >
                      Book a free consultation session to ask us about anything
                      you like. We will be happy to answer any questions you
                      have and we respond FAST!
                    </Typography>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => setConsultOpen(true)}
                      sx={{
                        background: "#0A8EF2",
                        color: "#ffff",
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        fontWeight: 600,
                        borderRadius: 2,
                        boxShadow: "0 6px 20px rgba(25, 118, 210, 0.3)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #1565c0, #1976d2)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 12px 24px rgba(25, 118, 210, 0.4)",
                        },
                      }}
                    >
                      Book Consultation Session
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {consultOpen && (
        <Box
          onClick={() => setConsultOpen(false)}
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(3px)",
            overflow: "hidden",
            overscrollBehavior: "none",
            p: 2,
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              width: { xs: "100%", md: "800px" },
              height: { xs: "75vh", md: "80vh" },
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ConsultationForm isModal onClose={() => setConsultOpen(false)} />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Contact;
